import { generateTestId } from "@client-shared";

export const setPrintingPreferencesViewTestId = () => {
  const component = "PrintingPreferencesView";
  return {
    container: generateTestId(component, "container"),
    batchPrintSection: generateTestId(component, "batch-print-section"),
    batchPrintGroup: generateTestId(component, "batch-print-group"),
    batchPrintLabelsOnly: generateTestId(component, "batch-print-labels-only"),
    batchPrintLabelsWithPackingSlips: generateTestId(component, "batch-print-labels-with-packing-slips"),
    paperSizeSection: generateTestId(component, "paper-size-section"),
    paperSizeGroup: generateTestId(component, "paper-size-group"),
    paperSize4x6: generateTestId(component, "paper-size-4x6"),
    paperSize3x4: generateTestId(component, "paper-size-3x4"),
    paperSizeA6: generateTestId(component, "paper-size-a6"),
    paperSizeA4: generateTestId(component, "paper-size-a4"),
    paperSizeLetter: generateTestId(component, "paper-size-letter"),
    groupBySection: generateTestId(component, "group-by-section"),
    groupByProduct: generateTestId(component, "group-by-product"),
    groupByGrind: generateTestId(component, "group-by-grind"),
    groupByQuantity: generateTestId(component, "group-by-quantity"),
    labelOptionsSection: generateTestId(component, "label-options-section"),
    displayPoNumberToggle: generateTestId(component, "display-po-number-toggle"),
    saveButton: generateTestId(component, "save-button"),
    notAvailableAlert: generateTestId(component, "not-available-alert"),
  };
};
